const TYPE = `[BUSINESS]`;

const Types = {
    // Dashboard
    FETCH_DASHBOARD_START: `${TYPE} FETCH DASHBOARD START`,
    FETCH_DASHBOARD_SUCCESS: `${TYPE} FETCH DASHBOARD SUCCESS`,
    FETCH_DASHBOARD_ERROR: `${TYPE} FETCH DASHBOARD ERROR`,
    
    // Employees
    FETCH_EMPLOYEES_START: `${TYPE} FETCH EMPLOYEES START`,
    FETCH_EMPLOYEES_SUCCESS: `${TYPE} FETCH EMPLOYEES SUCCESS`,
    FETCH_EMPLOYEES_ERROR: `${TYPE} FETCH EMPLOYEES ERROR`,

    ADD_EMPLOYEE_START: `${TYPE} ADD EMPLOYEE START`,
    ADD_EMPLOYEE_SUCCESS: `${TYPE} ADD EMPLOYEE SUCCESS`,
    ADD_EMPLOYEE_ERROR: `${TYPE} ADD EMPLOYEE ERROR`,

    DELETE_EMPLOYEE_START: `${TYPE} DELETE EMPLOYEE START`,
    DELETE_EMPLOYEE_SUCCESS: `${TYPE} DELETE EMPLOYEE SUCCESS`,
    DELETE_EMPLOYEE_ERROR: `${TYPE} DELETE EMPLOYEE ERROR`,

    ASSIGN_SESSIONS_START: `${TYPE} ASSIGN SESSIONS START`,
    ASSIGN_SESSIONS_SUCCESS: `${TYPE} ASSIGN SESSIONS SUCCESS`,
    ASSIGN_SESSIONS_ERROR: `${TYPE} ASSIGN SESSIONS ERROR`,
    
    // Tokens
    FETCH_TOKEN_HISTORY_START: `${TYPE} FETCH TOKEN HISTORY START`,
    FETCH_TOKEN_HISTORY_SUCCESS: `${TYPE} FETCH TOKEN HISTORY SUCCESS`,
    FETCH_TOKEN_HISTORY_ERROR: `${TYPE} FETCH TOKEN HISTORY ERROR`,

    PURCHASE_TOKENS_START: `${TYPE} PURCHASE TOKENS START`,
    PURCHASE_TOKENS_SUCCESS: `${TYPE} PURCHASE TOKENS SUCCESS`,
    PURCHASE_TOKENS_ERROR: `${TYPE} PURCHASE TOKENS ERROR`,

    // Reports
    EXPORT_NOM035_START: `${TYPE} EXPORT NOM035 START`,
    EXPORT_NOM035_SUCCESS: `${TYPE} EXPORT NOM035 SUCCESS`,
    EXPORT_NOM035_ERROR: `${TYPE} EXPORT NOM035 ERROR`,

    // Wellness Summary (NOM-035)
    FETCH_WELLNESS_SUMMARY_START: `${TYPE} FETCH WELLNESS SUMMARY START`,
    FETCH_WELLNESS_SUMMARY_SUCCESS: `${TYPE} FETCH WELLNESS SUMMARY SUCCESS`,
    FETCH_WELLNESS_SUMMARY_ERROR: `${TYPE} FETCH WELLNESS SUMMARY ERROR`,

    RESET_ERROR: `${TYPE} RESET ERROR`,
}

export default Types;
